import { IStampUserMissionInfo } from 'src/interfaces/user-mobile/stamp.interface';

function getMissionComplete(
  stampUserMissionInfo: IStampUserMissionInfo[],
  finishCnt: number,
) {
  const completeCnt = stampUserMissionInfo?.filter(item => item.clear).length;
  return completeCnt >= finishCnt;
}

export default getMissionComplete;
